import { observer } from "mobx-react";
import { Route as ReactRouterDomRoute, RouteComponentProps } from "react-router-dom";

const Route = ReactRouterDomRoute as any;

interface IProps {
  Component: React.FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
}

export const CustomRoute = observer(({ Component, path, exact }: IProps) => {
  // any guards here
  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps) => <Component {...props} />}
    />
  );
});
